import { useState } from 'react';
import instance from '@src/api/axiosInstance';
import { logger } from '@src/utils/misc/logger';

interface CreateShareResponse {
  share_id: string;
}

export const useCreateShare = () => {
  const [shareId, setShareId] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createShare = async (sessionId: string) => {
    setLoading(true);
    setError(null);
    setShareId(null);

    try {
      const response = await instance.post<CreateShareResponse>('/nexa/share/create', {
        session_id: sessionId,
      });

      setShareId(response.data.share_id);
      logger.log('Share created successfully', { share_id: response.data.share_id });
      return response.data.share_id;
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || 'Failed to create share link';
      setError(errorMessage);
      logger.error('Failed to create share', err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { createShare, shareId, loading, error };
};
